import * as ko from "knockout";
import * as localisationHelper from "localisationHelper";
import { EthnicOriginService } from "Content/ts/Shared/Inputs/EthnicOrigin/ethnicOriginService";

import { SelectDropdownOptions } from "Content/ts/Models/Controls/inputSelectOptions";
import { IInputSelect } from "Content/ts/Shared/Inputs/Select/input-select";

import 'Content/ts/Shared/Inputs/Select/input-select';

export const Deps = {
    LocalisationHelper: localisationHelper,
}

type booleanType = boolean | KnockoutObservable<boolean>;

export default class EthnicOriginSelect {
    loading: KnockoutObservable<boolean>;
    options: KnockoutObservableArray<SelectDropdownOptions>;
    value: KnockoutObservable<any>;
    validationFields: KnockoutObservable<any>[];
    text: string | KnockoutObservable<string>;
    isDisabled: booleanType;
    isReadOnly: booleanType;
    isRequired: booleanType;
    isVisible: KnockoutComputed<boolean>;
    placeholderMessage: string;

    constructor(params: IInputSelect) {
        this.loading = ko.observable(true);
        this.value = params.Value;
        this.text = params.Text || localisationHelper.getString("AccountResources", "Register_EthnicOrigin");
        this.isRequired = params.IsRequired || false;
        this.isDisabled = params.IsDisabled || false;
        this.isReadOnly = params.IsReadOnly || false;
        this.options = ko.observableArray([]);
        this.placeholderMessage = params.PlaceholderMessage

        this.validationFields = params.ValidationFields || [];
        var loadingSub = this.ensureValueIsPreselected();

        EthnicOriginService.RetrieveEthnicOrigins().then((data) => {
            this.options(data.map((value): SelectDropdownOptions => {
                return {
                    Id: value.Id,
                    Text: value.Description
                }
            }));
        }).finally(() => {
            if (loadingSub)
            {
                loadingSub.dispose();
            }
            //The below is required in order to clear the initial validation error that is shown when the options are loaded if isRequired = true
            //Bad UX to show an error before the user has even had a chance to enter a value.
            if (this.value.isModified && this.value.isModified()) {
                this.value.isModified(false);
            }
            this.loading(false);
        });

        this.isVisible = ko.pureComputed(() => {
            return this.options().length > 0;
        });
    }

    private ensureValueIsPreselected(): KnockoutSubscription {
        //Due to a bug with knockout, if the value is set before the list of options finishes loading, then without the below code, it does not get pre-selected.
        //This is because when the control is drawn, if the value to select is not in the list of options, it will instead be set to null.
        //This code compensates for that by adding the option to be pre-selected into the options list whilst the list is still loading.
        //When the options finish loading, the UI will then respect the pre-selected value.

        //We return the subscription so that we can dispose of it when the options list has finished loading,
        // otherwise anytime an option was selected, it would re-add it to the list!
        var value = this.value();
        if (value !== null && value !== undefined) {
            this.options.push({ Id: value, Text: "" });
        }
        else {
            return this.value.subscribe((newVal) => {
                if (this.loading() && newVal !== null && newVal !== undefined) {
                    this.options.push({ Id: newVal, Text: "" });
                }
            });
        }

        return null;
    }
}

const componentName = "ethnic-origin-select";
ko.components.unregister(componentName);
ko.components.register(componentName, {
    viewModel: EthnicOriginSelect,
    template: { require: `text!Content/ts/Shared/Inputs/EthnicOrigin/${componentName}.html` }
});